/**
 * Application logger.
 *
 * 127 bare console.* calls shipped to production before this existed, most of
 * them in the service layer. Routing them through one module means the
 * noise can be silenced in a production build, and gives a single place to
 * forward errors to a reporting service later.
 *
 * `error` still writes in production: a failure the user just hit is worth
 * having in the console when someone reports it.
 */
const isProduction = process.env.NODE_ENV === "production";

export const logger = {
  error: (message: string, ...details: unknown[]): void => {
    console.error(message, ...details);
  },

  warn: (message: string, ...details: unknown[]): void => {
    if (!isProduction) console.warn(message, ...details);
  },

  info: (message: string, ...details: unknown[]): void => {
    if (!isProduction) console.info(message, ...details);
  },

  debug: (message: string, ...details: unknown[]): void => {
    if (!isProduction) console.debug(message, ...details);
  },
};

export default logger;
